import { axios } from "~/plugins/request"

export function getDictionary(params) {
  return axios({
    method: 'post',
    url: '/fwxtdictionary/findAllItemByTypeCode',
    params: params
  })
}

export function findBasicConfigData(data) {
  return axios({
    method: 'get',
		url: '/report/initialPlan/findBasicConfigData',
    params: data
  })
}

export function saveLeaveMessage(data) {
  return axios({
    method: 'post',
		url: '/report/initialPlan/saveLeaveMessage',
    data: data
  })
}

export function findSpecialityList(data) {
  return axios({
    method: 'post',
		url: '/report/newPlan/findUniversityQueryList',
    data: data
  })
}

export function save(data) {
  return axios({
    method: 'post',
		url: '/report/newPlan/save',
    data: data
  })
}

export function findSchemeList(data) {
  return axios({
    method: 'post',
		url: '/report/newPlan/selectSchemeList',
    data: data
  })
}

export function getSchemeDetail(data) {
  return axios({
    method: 'get',
		url: '/report/newPlan/selectProgramInfo',
    params: data
  })
}

export function getSchemeDetailEdit(data) {
  return axios({
    method: 'get',
		url: '/report/newPlan/selectProgramInfoEdit',
    params: data
  })
}

export function remove(data) {
  return axios({
    method: 'get',
		url: '/report/initialPlan/remove',
    params: data
  })
}

export function saveAndSend(data) {
  return axios({
    method: 'get',
		url: '/report/initialPlan/sendScheme',
    params: data
  })
}


export function saveOrUpdateField(data) {
  return axios({
    method: 'post',
		url: '/configPlanField/saveOrUpdateField',
    data: data
  })
}




